import React from 'react';
import '../styles/Modal.css';

function DeleteConfirmModal({ clientName, onConfirm, onCancel, hasData }) {
  const isArchive = hasData;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-icon">{isArchive ? '📦' : '🗑️'}</div>
        <h2>{isArchive ? 'Archive Client?' : 'Delete Client?'}</h2>
        <p>
          {isArchive ? (
            <>
              <strong>{clientName}</strong> has existing data (posts, analytics, or reports).
              <br />
              They will be <strong>archived</strong> and can be restored later.
            </>
          ) : (
            <>
              Are you sure you want to delete <strong>{clientName}</strong>?
              <br />
              This client has no data and will be permanently removed.
            </>
          )}
        </p>
        <div className="modal-actions">
          <button onClick={onCancel} className="btn-secondary">
            Cancel
          </button>
          <button onClick={onConfirm} className="btn-danger">
            {isArchive ? 'Archive' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmModal;